import { get, post } from '@/api/index';
export const sample = params => get(`/api/paper/v1/sample`, params); // 考点组题
export const updatecollect = params => post(`/api/paper/v1/updatecollect`, params); //添加收藏
export const delcollect = params => post(`/api/paper/v1/delcollect`, params); //删除收藏
export const papermain = params => post(`/api/paper/v1/papermain`, params); //试卷缓冲页
export const paperinfo = params => post(`/api/paper/v1/info`, params); //试卷详情
export const weakspot = params => get(`/api/paper/v1/weakspot`, params); // 弱项组题
export const question = params => get(`/api/paper/v1/question`, params); // 查询单题
export const delwrong = params => post(`/api/paper/v1/delwrong`, params); //错题删除
